import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from 'src/app/app.contant';
import { IAPIResponse, ILineItemDetail, IPurchaseRequest } from '../../shared/models';
import { EncryptionService } from './encryption.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient, private _encryptionService: EncryptionService) { }

  public getPurchaseRequests(): Observable<IAPIResponse<Array<IPurchaseRequest>>> {
    return this.http.get<IAPIResponse<Array<IPurchaseRequest>>>(`${API_URL.GET_ALL_PR}`);
  }

  public getBuyerPurchaseRequests(): Observable<IAPIResponse<Array<IPurchaseRequest>>> {
    return this.http.get<IAPIResponse<Array<IPurchaseRequest>>>(`${API_URL.BUYER.GET_ALL_PR}`);
  }

  public getPurchaseRequestDetail(prId : string): Observable<IAPIResponse<Array<IPurchaseRequest>>> {
    const id = parseInt(prId)
    return this.http.get<IAPIResponse<Array<any>>>(`${API_URL.GET_ALL_PR}?prId=${id}`);
  }

  public getMangaerExcelReport(startDate : string, endDate: string): Observable<any> {
    return this.http.post<any>(`${API_URL.GET_MANAGER_REPORT}`, {startDate : startDate, endDate : endDate});
  }

  public updatePurchaseRequestDetail(purchaseRequest : IPurchaseRequest, prFiles:any): Observable<any> {
    let formData: FormData = new FormData();
    formData.append("prData", JSON.stringify(purchaseRequest));
    if(prFiles?.length){
      prFiles.forEach((element:any) => {
        if(!element.id){
          formData.append("files", element)
        }
      });
    } else{
      formData.append("files","");
    }
    return this.http.post<any>(`${API_URL.UPDATE_PR}`, formData);
  }

  public createPR(purchaseRequest : any, prFiles?: any) : Observable<any> {
    let formData: FormData = new FormData;
    formData.append("prData", JSON.stringify(purchaseRequest));
    if(prFiles?.length){
      prFiles.forEach((element:any) => {
        formData.append("files", element)
      });
    } else{
      formData.append("files","");
    }
    return this.http.post<any>(`${API_URL.CREATE_PR}`, formData);
    // return of(true)
  }

  public removePurchaseRequest(prIds : any): Observable<any> {
    return this.http.post<any>(`${API_URL.DELETE_PR}`, prIds);
  }

  public archiveOrUndoPurchaseRequest(status:any,prIds : any): Observable<any> {
    return this.http.post<any>(`${API_URL.ARCHIVE_PR}`, {status:status,prIds : prIds});
  }

  // generic API for PRs to be used in dashboard

  public fetchDashboardPRs(url : string) : Observable<IAPIResponse<Array<IPurchaseRequest>>> {
    return this.http.get<IAPIResponse<Array<IPurchaseRequest>>>(`${url}`);
  }

  public fetchUnregisterVeendor(url:string,isRegisterVendor:boolean): Observable<IAPIResponse<Array<IPurchaseRequest>>> {
    return this.http.get<IAPIResponse<Array<IPurchaseRequest>>>(`${url}${isRegisterVendor}`);
  }

  /////line item

  public removeLinteItem(material_master_id : any) : Observable<any> {
    const id = parseInt(material_master_id)
    return this.http.post<any>(`${API_URL.LINE_ITEM.DELETE}`, {material_master_id : id});
  }

  public addLinteItem(line_items : Array<ILineItemDetail>) : Observable<any> {
    return this.http.post<any>(`${API_URL.LINE_ITEM.ADD}`, {line_items});
  }

  public sendReminder(prDetails: any) {
    return this.http.post<IAPIResponse<any>>(`${API_URL.SEND_REMAINDER}prId=${this._encryptionService.encryptPayload(prDetails?.prId)}`, prDetails);
  }

  public assignToBuyer(prDetails: any) {    
    return this.http.post<IAPIResponse<any>>(`${API_URL.BUYER.ASSIGN_TO_MYSELF}prId=${this._encryptionService.encryptPayload(prDetails?.prId)}`, null);
  }

  public getRequestorDashboardDetails(): Observable<any>{
    return this.http.get<IAPIResponse<any>>(`${API_URL.DASHBOARD}`)
  }

  public getPrHistory(prId:any):Observable<any>{
    return this.http.get<IAPIResponse<any>>(`${API_URL.PR_HISTORY}${prId}`)
  }

  public prApprovalByManager(line_items:any) : Observable<any> {
    console.log('lll',line_items)
    return this.http.post<any>(`${API_URL.PR_APPROVAL_BY_MANAGER}`, line_items);
  }

  public downloadLineItemsTemplate(prId:any): Observable<Blob> {
    return this.http.get<Blob>(`${API_URL.DOWNLOAD_LINE_ITEMS_TEMPLATE}?prId=${prId}`, { responseType: 'blob' as any, });
  }

  public uploadBulkLineItems(formData : FormData, prId: any): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.UPLOAD_BULK_LINE_ITEMS}?prId=${this._encryptionService.encryptPayload(prId)}`, formData);
  }

}
